import { Permission } from '@retail/auth/types';

const dashboardPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'DASHBOARD',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'DASHBOARD',
    actions: ['READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
];

const assortmentPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'ASSORTMENT',
    actions: ['READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'ASSORTMENT',
    actions: ['READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'ASSORTMENT',
    actions: ['READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'ASSORTMENT',
    actions: ['READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'ASSORTMENT',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const assortmentItemsPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'ASSORTMENT_ITEMS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'ASSORTMENT_ITEMS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'ASSORTMENT_ITEMS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'ASSORTMENT_ITEMS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'ASSORTMENT_ITEMS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
];

const monitoringAssortmentItemsPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'MONITORING_ASSORTMENT_ITEMS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'MONITORING_ASSORTMENT_ITEMS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'MONITORING_ASSORTMENT_ITEMS',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
];

const priceCalculationPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'PRICE_CALCULATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'PRICE_CALCULATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'PRICE_CALCULATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const itemPricesPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__ITEM_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__ITEM_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'PRICE_CALCULATION__ITEM_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'PRICE_CALCULATION__ITEM_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION__ITEM_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'PRICE_CALCULATION__ITEM_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__ITEM_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const purchasePricesPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__PURCHASE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__PURCHASE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'PRICE_CALCULATION__PURCHASE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'PRICE_CALCULATION__PURCHASE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION__PURCHASE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__PURCHASE_CONDITION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const freightPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__FREIGHT',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__FREIGHT',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION__FREIGHT',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__FREIGHT',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const markupPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__MARKUP',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__MARKUP',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION__MARKUP',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__MARKUP',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const localPriceSuggestionsPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_SUGGESTIONS',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const priceSuggestionsPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION__PRICE_SUGGESTIONS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__PRICE_SUGGESTIONS',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const salesPriceConditionPermission: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__SALES_PRICE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__SALES_PRICE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION__SALES_PRICE_CONDITION',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__SALES_PRICE_CONDITION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const customerMarkupPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PRICE_CALCULATION__CUSTOMER_MARKUP',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'PRICE_CALCULATION__CUSTOMER_MARKUP',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['SE'],
  }),
];

const discountCustomersPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'DISCOUNT_CUSTOMERS',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
];

const roundingConditionsPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__ROUNDING',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__ROUNDING',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__ROUNDING',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];
const combinedConditionsPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CALCULATION__COMBINED',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CALCULATION__COMBINED',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PRICE_CALCULATION__COMBINED',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const itemSearchPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'ITEM_SEARCH',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const extendedMgItemInfoPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'EXTENDED_MG_ITEM_INFO',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
];

const marketInsightPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'MARKET_INSIGHT',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'MARKET_INSIGHT',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'MARKET_INSIGHT',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'MARKET_INSIGHT',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'MARKET_INSIGHT',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'MARKET_INSIGHT',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
];

const administrationPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'ADMINISTRATION',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const uploadPurchasePricesPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PURCHASE_PRICES',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PURCHASE_PRICES',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'PURCHASE_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'PURCHASE_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'PURCHASE_PRICES',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'PURCHASE_PRICES',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const itemExportPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'ITEM_EXPORT',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'ITEM_EXPORT',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'ITEM_EXPORT',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'ITEM_EXPORT',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'ITEM_EXPORT',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'ITEM_EXPORT',
    actions: ['READ'],
    appTenants: ['SE'],
  }),
];

const approvalPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'APPROVAL',
    actions: ['READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'APPROVAL',
    actions: ['READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'APPROVAL',
    actions: ['READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'APPROVAL',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'APPROVAL',
    actions: ['READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'APPROVAL',
    actions: ['READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
];
const priceControlPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'PRICE_CONTROL',
    actions: ['READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'PRICE_CONTROL',
    actions: ['READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
];

const campaignPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'CAMPAIGN',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'CAMPAIGN',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_PRICE_LIST',
    resource: 'CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const memberCampaignPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'MEMBER_CAMPAIGN',
    actions: ['READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'MEMBER_CAMPAIGN',
    actions: ['READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'MEMBER_CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'MEMBER_CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'MEMBER_CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const localCampaignPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'LOCAL_CAMPAIGN',
    actions: ['READ', 'CREATE', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'LOCAL_CAMPAIGN',
    actions: ['READ', 'CREATE', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'LOCAL_CAMPAIGN',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];
const centralAssortmentPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'CENTRAL_ASSORTMENT',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'CENTRAL_ASSORTMENT',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
];
const centralAssortmentMemberView: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'CENTRAL_ASSORTMENT_MEMBER_VIEW',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'CENTRAL_ASSORTMENT_MEMBER_VIEW',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT',
    resource: 'CENTRAL_ASSORTMENT_MEMBER_VIEW',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_LIGHT_PLUS',
    resource: 'CENTRAL_ASSORTMENT_MEMBER_VIEW',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_LOCATION',
    resource: 'CENTRAL_ASSORTMENT_MEMBER_VIEW',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'CENTRAL_ASSORTMENT_MEMBER_VIEW',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];
const subAssortmentsPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'SUB_ASSORTMENTS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'SUB_ASSORTMENTS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'SUB_ASSORTMENTS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'SUB_ASSORTMENTS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'SUB_ASSORTMENTS',
    actions: ['CREATE', 'READ', 'UPDATE'],
    appTenants: ['NO', 'SE'],
  }),
];
const supplierItemsInsightReportPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'SUPPLIER_ITEMS_INSIGHT_REPORT',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'WHOLESALE_BRAND',
    resource: 'SUPPLIER_ITEMS_INSIGHT_REPORT',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

const roundingPermissions: Permission[] = [
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_BRAND',
    resource: 'ROUNDING',
    actions: ['CREATE', 'READ', 'DELETE'],
    appTenants: ['SE', 'NO'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION',
    resource: 'ROUNDING',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['SE', 'NO'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_DATAOWNER',
    resource: 'ROUNDING',
    actions: ['CREATE', 'READ', 'UPDATE', 'DELETE'],
    appTenants: ['NO', 'SE'],
  }),
  new Permission({
    userRole: 'ADMIN',
    orgType: 'RETAIL_LOCATION_UNDER_MASTER',
    resource: 'ROUNDING',
    actions: ['READ'],
    appTenants: ['NO', 'SE'],
  }),
];

export const adminPermissions: Permission[] = [
  ...dashboardPermissions,
  ...administrationPermissions,
  ...assortmentPermissions,
  ...assortmentItemsPermissions,
  ...subAssortmentsPermissions,
  ...approvalPermissions,
  ...priceControlPermissions,
  ...monitoringAssortmentItemsPermissions,
  ...priceCalculationPermissions,
  ...itemPricesPermissions,
  ...purchasePricesPermissions,
  ...freightPermissions,
  ...markupPermissions,
  ...priceSuggestionsPermissions,
  ...localPriceSuggestionsPermissions,
  ...salesPriceConditionPermission,
  ...customerMarkupPermissions,
  ...combinedConditionsPermissions,
  ...discountCustomersPermissions,
  ...roundingConditionsPermissions,
  ...itemSearchPermissions,
  ...extendedMgItemInfoPermissions,
  ...marketInsightPermissions,
  ...itemExportPermissions,
  ...campaignPermissions,
  ...memberCampaignPermissions,
  ...localCampaignPermissions,
  ...centralAssortmentPermissions,
  ...centralAssortmentMemberView,
  ...uploadPurchasePricesPermissions,
  ...supplierItemsInsightReportPermissions,
  ...roundingPermissions,
];
